import React from 'react'

import styles from './buttonSecondary.module.scss'

const ButtonSecondary = props => {
  const { handleClick, title } = props

  return (
    <button className={styles.buttonSecondary} onClick={handleClick}>
      {!!props.children ? <span className={styles.wrapp}>{props.children}</span> : title}
    </button>
  )
}

export default React.memo(ButtonSecondary)